var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('page',{attrs:{"page-id":1}}):_c('div',{staticClass:"loader"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }